import { useEffect, useRef, useState } from "react";
import styles from "./index.module.less";
import classNames from "classnames";
import firstBg from "./imgs/case_1.png";
import { Flex, Typography } from "antd";
import Lottie from "lottie-react";
import useHoverLottie from "@/hooks/useHoverLottie";
import jiantou from "@/assets/lottie/jiantou.json";
import ArrowLine from "@/assets/imgs/arrow_line.svg?react";
import { useNavigate } from "react-router-dom";
import { solutionList } from "@/pages/solutions/data";
import SVGIcon from "@/components/SVGIcon";
const {Paragraph} = Typography
const firstItem = solutionList.find(item => item.company === '招商银行')
const cases = [
  {
    ...solutionList.find(item => item.company === '瑞众保险'),
  },
  {
    ...solutionList.find(item => item.company === '屈臣氏'),
  },
  {
    ...solutionList.find(item => item.company === '香港移动'),
  },
  {
    ...solutionList.find(item => item.company === '招商局集团'),
  },
  {
    ...solutionList.find(item => item.company === '华润集团'),
  },
];
const CaseCard = ({
  isActive,
  index = 0,
  title,
  company,
  desc,
  onMouseLeave,
  onMouseEnter,
}: {
  isActive?: boolean;
  onMouseLeave?: () => void;
  onMouseEnter?: () => void;
  index?: number;
  title?: string;
  company?: string;
  desc?: string;
}) => {
  const navigate = useNavigate();
  // 是否偶数
  const isEven = index && index % 2 === 0;

  return (
    <div
      className={classNames(styles.caseCard, {
        [styles.open]: isActive,
        [styles.even]: isEven,
        [styles.odd]: !isEven,
      })}
      onTouchStart={onMouseEnter}
      // onMouseLeave={onMouseLeave}
    >
      <Flex align="center" justify="space-between" className={styles.cardContentFold}>
        <div className={styles.cardTitle}>{company}</div>
        <div className={styles.cardIndex}>{index > 10 ? index : `0${index}`}</div>
      </Flex>
      <div className={styles.cardContentBox}>
        <Flex vertical gap={'.1rem'} className={styles.cardContent}>
          <div className={styles.cardIndex}>{index > 10 ? index : `0${index}`}</div>

          <Paragraph ellipsis={{
            rows: 1,
          }} className={styles.cardSubTitle}>{title}</Paragraph>
          <Paragraph ellipsis={{
            rows: 2,
          }}  className={styles.cardDesc}>{desc}</Paragraph>
          <Flex align="center" gap={'.04rem'}
            className={styles.cardFooter}
            onClick={() => {
              window.open(`/solutions?title=${title}`, '_blank');
            }}
          >
            查看
            <SVGIcon icon={<ArrowLine />} width={12}/>
          </Flex>
        </Flex>
      </div>
    </div>
  );
};

const CaseList = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(3);
  return (
    <Flex vertical className={styles.caseList}>
      <div className={styles.firstCard} onClick={() => {
        window.open(`/solutions?title=${firstItem.title}`, '_blank');
      }}>
        <img src={firstBg} />
        <div className={styles.firstCardContent}>
          <div>{firstItem.company}</div>
          <div>
            {firstItem.title}
          </div>
        </div>
        <div className={styles.firstCardIndex}>01</div>
      </div>
      {cases.map((item, index) => (
        <CaseCard
          key={index}
          {...item}
          onMouseEnter={() => setActiveIndex(index + 2)}
          onMouseLeave={() => setActiveIndex(3)}
          isActive={activeIndex === index + 2}
          index={index + 2}
        />
      ))}
    </Flex>
  );
};
export default CaseList;
